// ["ja","en","zh","ko"]で共通の転送用選択肢
module.exports = {
  transferSelect : "none"
};
